import { FC, useEffect, useState, } from 'react';
import { getStandardTaskSelection } from '@/common/api/expandStore/expansiontask';
import { FormItemProps, SelectProps } from 'antd';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';

/**
 * @Description 紧急度
 */
const FormEmergencyDegree:FC<{
  name: string;
  label?: string;
  rules?: any;
  placeholder?: string;
  selectConfig?: SelectProps;
  formConfig?: FormItemProps;
  required?: boolean;
}> = ({
  name,
  label,
  rules,
  placeholder,
  selectConfig,
  formConfig,
  required,
}) => {
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    getSelection();
  }, []);

  const getSelection = async () => {
    const options = await getStandardTaskSelection();

    const data = options?.emergencyDegree.map((item) => ({
      label: item.name,
      value: item.id
    })) || [];
    setOptions(data);
  };

  return (
    <V2FormSelect
      required={required}
      name={name}
      label={label}
      options={options}
      rules={rules}
      placeholder={placeholder}
      config={{
        showSearch: true,
        ...selectConfig
      }}
      formItemConfig={formConfig}
    />
  );
};

export default FormEmergencyDegree;
